import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import Brand, { BrandingCompany } from 'mbs-ui-shared@models/Brand';
import BrandLicense from 'mbs-ui-shared@models/BrandLicense';
import BrandVersion from 'mbs-ui-shared@models/BrandVersion';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandsService {
  private http = inject(HttpClient);

  private readonly baseHref = '/api/brands';

  getAll(): Observable<Brand[]> {
    return this.http.get<Brand[]>(this.baseHref);
  }

  getByKey(id: string): Observable<Brand> {
    return this.http.get<Brand>(`${this.baseHref}/${id}`);
  }

  add(brand: Brand): Observable<Brand> {
    return this.http.post<Brand>(this.baseHref, brand);
  }

  update(brand: Brand): Observable<Brand> {
    return this.http.put<Brand>(`${this.baseHref}/${brand.id}`, brand);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.baseHref}/${id}`);
  }

  getVersions$(brandId: string): Observable<BrandVersion[]> {
    return this.http.get<BrandVersion[]>(`${this.baseHref}/${brandId}/versions`);
  }

  getDownloadLink$(brandId: string, code: string): Observable<string> {
    return this.http.get(`${this.baseHref}/${brandId}/geturl`, { params: { code }, responseType: 'text' });
  }

  getDefault$(): Observable<Brand> {
    return this.http.get<Brand>(`${this.baseHref}/default`);
  }

  getActive$(): Observable<Brand[]> {
    return this.http.get<Brand[]>(`${this.baseHref}`, { params: { onlyActive: 'true' } });
  }

  getAllBrandingCompanies$(): Observable<BrandingCompany[]> {
    return this.http.get<BrandingCompany[]>(`${this.baseHref}/allcompanies`);
  }

  checkSymbols$(value: string): Observable<any> {
    return this.http.get(`${this.baseHref}/checkname`, {
      headers: new HttpHeaders({ MANUAL_ERROR_HANDLED: 'MANUAL_ERROR_HANDLED' }),
      params: { name: value }
    });
  }

  getLicenses(): Observable<BrandLicense[]> {
    return this.http.get<BrandLicense[]>(`${this.baseHref}/licenses`);
  }

  assignLicenseToBrand$(licenseId: string, brandId: string): Observable<void> {
    return this.http.put<void>(`${this.baseHref}/licenses/${licenseId}/assign`, { BrandId: brandId });
  }
}
